import React, { createRef, forwardRef, useState } from "react";
import { useEffect } from "react";
import ReactDOM from "react-dom";


function Modal(props) {
    if (!props.show) {
        return null;
    }

    /*const closeOnEscape = (e) => {
        if ((e.charCode || e.keyCode) === 27) {
            props.onClose();
        }
    }

    useEffect(() => {
        document.body.addEventListener("keydown", closeOnEscape)
        return function cleanup() {
            document.body.removeEventListener("keydown", closeOnEscape)
        }
    },[])*/
    //onClick={props.onClose}
    return (
        <>
            <div className="modal no-border" >
                <div className="modal-content" onClick={e => e.stopPropagation()} style={props.styleProps}>
                    <div className="modal-header" style={props.styleHeaderProps }>
                        <div className="modal-title title-statistic">{props.titleProps}</div>
                        <div className="closeAsbCR">
                            <i onClick={props.onClose} className="fa-solid fa-xmark closeButton"></i>
                        </div>
                    </div>
                    <div className="modal-body">
                        {props.children}
                    </div>
                </div>
            </div>
        </>
    );

}
export default Modal;
/*
 <div className="modal-footer">
                        <button onClick={props.onClose}  className="btn btn-secondary m-1 lift">Close</button>
                        <button onClick={props.onClose}  className="btn btn-primary m-1 sharenow">Yes</button>
                    </div>
                    */